/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserReadExtendedDto
 */
export interface UserReadExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    phoneNumber?: string | null;
    /**
     * Добавочный телефон
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    workPhone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserReadExtendedDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserReadExtendedDto
     */
    isMustChangePassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserReadExtendedDto
     */
    isOwnedByClient?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    impersonatingUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReadExtendedDto
     */
    impersonatingUserLogin?: string | null;
}

/**
 * Check if a given object implements the UserReadExtendedDto interface.
 */
export function instanceOfUserReadExtendedDto(value: object): value is UserReadExtendedDto {
    return true;
}

export function UserReadExtendedDtoFromJSON(json: any): UserReadExtendedDto {
    return UserReadExtendedDtoFromJSONTyped(json, false);
}

export function UserReadExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReadExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'workPhone': json['workPhone'] == null ? undefined : json['workPhone'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'isMustChangePassword': json['isMustChangePassword'] == null ? undefined : json['isMustChangePassword'],
        'isOwnedByClient': json['isOwnedByClient'] == null ? undefined : json['isOwnedByClient'],
        'impersonatingUserId': json['impersonatingUserId'] == null ? undefined : json['impersonatingUserId'],
        'impersonatingUserLogin': json['impersonatingUserLogin'] == null ? undefined : json['impersonatingUserLogin'],
    };
}

export function UserReadExtendedDtoToJSON(json: any): UserReadExtendedDto {
    return UserReadExtendedDtoToJSONTyped(json, false);
}

export function UserReadExtendedDtoToJSONTyped(value?: UserReadExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userName': value['userName'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'workPhone': value['workPhone'],
        'isEnabled': value['isEnabled'],
        'isMustChangePassword': value['isMustChangePassword'],
        'isOwnedByClient': value['isOwnedByClient'],
        'impersonatingUserId': value['impersonatingUserId'],
        'impersonatingUserLogin': value['impersonatingUserLogin'],
    };
}

